<template>
	<div>
		<!-- Rechnungsempfänger -->
		<div class="grid grid-cols-6 gap-6 w-full mb-4">
			<div class="col-span-6">
				<h2 class="text-xl font-semibold text-brand">
					Rechnungsempfänger
				</h2>
			</div>
		</div>
		<div class="grid grid-cols-6 gap-6 mb-12">
			<div class="col-span-6 sm:col-span-1">
				<f-select
					v-model="Anrede"
					required
					label="Anrede"
					placeholder="Anrede"
					:options="anredeOptions"
					:error-message="errors['Rechnung.Anrede']"
				/>
			</div>
			<div class="col-span-6 sm:col-span-3">
				<f-text-field
					id="vorname"
					v-model="Vorname"
					required
					label="Vorname"
					name="vorname"
					placeholder="Vorname"
					:error-message="errors['Rechnung.Vorname']"
				/>
			</div>
			<div class="col-span-6 sm:col-span-2">
				<f-text-field
					id="nachname"
					v-model="Nachname"
					required
					label="Nachname"
					name="nachname"
					placeholder="Nachname"
					:error-message="errors['Rechnung.Nachname']"
				/>
			</div>
			<div
				v-if="Kundenart && Kundenart.value === 'Unternehmen'"
				ref="hiddenEl"
				class="grid grid-cols-6 gap-6 w-full col-span-6"
			>
				<div class="col-span-6 sm:col-span-3">
					<f-text-field
						id="firma"
						v-model="Firma"
						required
						label="Firma"
						name="firma"
						placeholder="Firma"
						:error-message="errors['Rechnung.Firma']"
					/>
				</div>
				<div class="col-span-6 sm:col-span-3">
					<f-text-field
						id="USt-IdNr."
						v-model="VAT"
						label="USt-IdNr."
						name="USt-IdNr."
						placeholder="USt-IdNr."
						:error-message="errors['Rechnung.VAT-ID']"
						:tooltip-message="tooltipMessage"
					/>
				</div>
			</div>
			<div class="col-span-6 sm:col-span-3">
				<f-text-field
					id="straße"
					v-model="Street"
					required
					label="Straße + Hausnr."
					name="straße"
					placeholder="Straße + Hausnr."
					:error-message="errors['Rechnung.Straße']"
				/>
			</div>
			<div class="col-span-6 sm:col-span-1">
				<f-text-field
					id="postleitzahl"
					v-model="Postleitzahl"
					required
					label="Postleitzahl"
					name="postleitzahl"
					placeholder="Postleitzahl"
					:error-message="errors['Rechnung.Postleitzahl']"
				/>
			</div>
			<div class="col-span-6 sm:col-span-2">
				<f-text-field
					id="ort"
					v-model="Ort"
					required
					label="Ort"
					name="ort"
					placeholder="Ort"
					:error-message="errors['Rechnung.Ort']"
				/>
			</div>
			<div class="col-span-6 sm:col-span-2">
				<f-select
					v-model="Land"
					required
					label="Land"
					:options="landOptions"
					:error-message="errors['Rechnung.Land']"
				/>
			</div>
			<div class="col-span-6 sm:col-span-2">
				<f-text-field
					id="telefon"
					v-model="Telefon"
					label="Telefon"
					name="telefon"
					placeholder="Telefon"
					:error-message="errors['Rechnung.Telefon']"
				/>
			</div>
			<div class="col-span-6 sm:col-span-2">
				<f-text-field
					id="email"
					v-model="Email"
					label="Email"
					name="email"
					placeholder="Email"
					type="email"
					required
					:error-message="errors['Rechnung.Email']"
				/>
			</div>
		</div>

		<div class="w-full border-t border-1 border-gray-200 mt-16 mb-8" />

		<!-- Zahlungsart -->
		<div class="flex w-full justify-between mb-6">
			<h2 class="text-xl font-semibold text-brand">Zahlungsart</h2>
		</div>
		<div class="grid grid-cols-6 gap-6">
			<div
				class="col-span-6 sm:col-span-2 pt-4 text-sm font-medium text-gray-700"
			>
				Zahlungsart
			</div>
			<div class="col-span-6 sm:col-span-4 mb-6">
				<!-- <f-group-radio
					v-model="Zahlungsart"
					required
					label=""
					:options="zahlungsartOptions"
					:error-message="errors.Zahlungsart"
				/> -->
				<RadioGroup v-model="Zahlungsart">
					<div class="bg-white rounded-md -space-y-px mt-2">
						<RadioGroupOption
							v-for="(option, index) in zahlungsartOptions"
							:key="option.name"
							v-slot="{ checked }"
							as="div"
							:value="option"
							tabindex="0"
						>
							<div
								:class="[
									index === 0 ? 'rounded-tl-md rounded-tr-md' : '',
									index === zahlungsartOptions.length - 1
										? Zahlungsart &&
										  Zahlungsart.value === 'SEPA-Lastschriftverfahren'
											? 'border-1 border-b-0'
											: 'rounded-bl-md rounded-br-md'
										: '',
									checked
										? 'bg-blue-50 border-secondary z-10'
										: 'border-gray-200',
									'relative border border-1 p-4 cursor-pointer focus:outline-none',
								]"
							>
								<div class="flex">
									<span
										:class="[
											checked
												? 'bg-secondary border-transparent'
												: 'bg-white border-gray-300',
											'h-4 w-4 mt-0.5 cursor-pointer rounded-full border flex items-center justify-center',
										]"
										aria-hidden="true"
									>
										<span class="rounded-full bg-white w-1.5 h-1.5" />
									</span>
									<div class="ml-3 flex flex-col">
										<RadioGroupLabel
											as="span"
											:class="[
												checked ? 'text-brand' : 'text-gray-800',
												'block text-sm font-medium',
											]"
										>
											{{ option.name }}
										</RadioGroupLabel>
										<RadioGroupDescription
											v-if="option.description"
											as="span"
											:class="[
												checked ? 'text-secondary' : 'text-gray-400',
												'block text-sm',
											]"
										>
											{{ option.description }}
										</RadioGroupDescription>
									</div>
								</div>
							</div>
						</RadioGroupOption>
					</div>
				</RadioGroup>
				<div
					v-if="
						Zahlungsart && Zahlungsart.value === 'SEPA-Lastschriftverfahren'
					"
					class="grid grid-cols-6 gap-x-6 px-6 py-6 bg-blue-50 rounded-b-md border border-t-0 border-secondary z-30"
				>
					<div
						class="col-span-6 sm:col-span-2 pt-3 text-sm font-medium text-gray-700"
					>
						IBAN
					</div>
					<div ref="hiddenEl2" class="col-span-6 sm:col-span-4 mb-2">
						<f-text-field
							id="IBAN"
							v-model="IBAN"
							required
							label=""
							name="IBAN"
							placeholder="IBAN"
							:error-message="errors.IBAN"
						/>
					</div>

					<div
						class="col-span-6 sm:col-span-2 pt-3 text-sm font-medium text-gray-700"
					>
						BANK
					</div>
					<div class="col-span-6 sm:col-span-4 mb-2">
						<f-text-field
							id="Bank"
							v-model="Bank"
							required
							label=""
							name="Bank"
							placeholder="Bank"
							:error-message="errors.Bank"
						/>
					</div>

					<div
						class="col-span-6 sm:col-span-2 pt-3 text-sm font-medium text-gray-700"
					>
						Kontoinhaber
					</div>
					<div class="col-span-6 sm:col-span-4 mb-2">
						<f-text-field
							id="Kontoinhaber"
							v-model="Kontoinhaber"
							label=""
							name="Kontoinhaber"
							placeholder="Kontoinhaber"
						/>
					</div>

					<div
						class="col-span-6 sm:col-span-2 pt-3 text-sm font-medium text-gray-700"
					>
						BIC
					</div>
					<div class="col-span-6 sm:col-span-4 mb-2">
						<f-text-field
							id="BIC"
							v-model="BIC"
							label=""
							name="BIC"
							placeholder="BIC"
						/>
						<p class="text-xs text-gray-400 mt-2">
							(nur bei nicht deutschem Bankkonto)
						</p>
					</div>

					<div
						class="col-span-6 sm:col-span-2 text-sm font-medium text-gray-700"
					>
						Gläubiger ID
					</div>
					<div class="col-span-6 sm:col-span-4 mb-2">
						<p class="font-medium text-gray-500 text-sm">DE48ZZZ00001435190</p>
					</div>

					<div
						class="col-span-6 sm:col-span-2 text-sm font-medium text-gray-700"
					>
						Mandatsreferenz
					</div>
					<div class="col-span-6 sm:col-span-4 mb-2">
						<p class="font-medium text-gray-500 text-sm">1</p>
					</div>
				</div>
			</div>

			<div class="col-span-6 sm:col-span-2" />
			<div class="col-span-6 sm:col-span-4">
				<f-checkbox
					id="agb"
					v-model="AGB"
					label=""
					name="agb"
					:html="AGB_HTML"
					:error-message="errors.AGB"
				/>
			</div>

			<div class="col-span-6 sm:col-span-2" />
			<div class="col-span-6 sm:col-span-4">
				<f-checkbox
					id="widerrufsrecht"
					v-model="Widerrufsrecht"
					label=""
					name="widerrufsrecht"
					:description="widerrufsrechtDescription"
					:error-message="errors.Widerrufsrecht"
				/>
			</div>

			<div class="col-span-6 sm:col-span-2" />
		</div>
	</div>
</template>

<script>
import FTextField from '@/components/FormFields/FTextField.vue'
import FSelect from '@/components/FormFields/FSelect.vue'
import FCheckbox from '@/components/FormFields/FCheckbox.vue'

import OPTIONS from '@/data/select__options.js'
import RADIO_OPTIONS from '@/data/radio__options.js'
import TOOLTIP_MESSAGES from '@/data/tooltip__messages.js'

import {
	RadioGroup,
	RadioGroupDescription,
	RadioGroupLabel,
	RadioGroupOption,
} from '@headlessui/vue'

import {
	useForm,
	useField,
	useIsFormValid,
	useIsFormDirty,
	useFormValues,
	useValidateForm,
} from 'vee-validate'
import * as yup from 'yup'

import { ref, computed, watchEffect, watch, onMounted } from 'vue'
import { useStore } from 'vuex'

const AGB_URL = 'https://www.ohne-makler.net/allgemeine-geschaeftsbedingungen/'
const AGB_HTML = `
<p class="text-gray-700 text-sm">
  Ich akzeptiere die
  <a href="${AGB_URL}" target="_blank" class="underline">AGB</a>
  von ohne-makler.net.
</p>
`

const widerrufsrechtDescription = `
  Ich stimme ausdrücklich zu, dass Sie vor Ablauf der Widerrufsfrist mit
  der Ausführung der Leistung beginnen. Mir ist bekannt, dass ich durch
  diese Zustimmung mit Beginn der Ausführung der Leistung mein Widerrufsrecht
  verliere.
`

export default {
	components: {
		FTextField,
		FSelect,
		FCheckbox,

		RadioGroup,
		RadioGroupDescription,
		RadioGroupLabel,
		RadioGroupOption,
	},
	emits: ['changed'],
	setup(_, { emit }) {
		const store = useStore()

		const tooltipMessage = TOOLTIP_MESSAGES.ustIdnr

		const hiddenEl = ref(null)
		const hiddenEl2 = ref(null)

		const schema = computed(() => {
			return yup.object({
				Rechnung: yup.object({
					Kundenart: yup
						.object()
						.test(
							'Kundenart',
							'Bitte füllen Sie das Feld "Kundenart" aus.',
							(val) => (!val || !val.value ? false : true)
						),
					Anrede: yup
						.object()
						.test('Anrede', 'Bitte füllen Sie das Feld "Anrede" aus.', (val) =>
							!val || !val.value ? false : true
						),
					Vorname: yup
						.string()
						.required('Bitte füllen Sie das Feld "Vorname" aus.'),
					Nachname: yup
						.string()
						.required('Bitte füllen Sie das Feld "Nachname" aus.'),
					Straße: yup
						.string()
						.required('Bitte füllen Sie das Feld "Straße" aus.'),
					Postleitzahl: yup
						.string()
						.required('Bitte füllen Sie das Feld "Postleitzahl" aus.'),
					Ort: yup.string().required('Bitte füllen Sie das Feld "Ort" aus.'),
					Land: yup
						.object()
						.test('Land', 'Bitte füllen Sie das Feld "Land" aus.', (val) =>
							!val || !val.value ? false : true
						),
					Telefon: yup.string(),
					Email: yup
						.string()
						.email('Ungültige E-Mail-Adresse')
						.required('Bitte füllen Sie das Feld "Email" aus.'),
					Firma: hiddenEl.value
						? yup.string().required('Bitte füllen Sie das Feld "Firma" aus.')
						: null,
					'VAT-ID': hiddenEl.value ? yup.string() : null,
				}),
				Zahlungsart: yup
					.object()
					.test(
						'Zahlungsart',
						'Bitte füllen Sie das Feld "Zahlungsart" aus.',
						(val) => (!val || !val.value ? false : true)
					),
				AGB: yup.boolean().oneOf([true], 'Sie müssen den AGB zustimmen'),
				Widerrufsrecht: yup
					.boolean()
					.oneOf([true], 'Sie müssen dem zustimmen.'),
				Ausgedruckt: yup.boolean(),
				IBAN: hiddenEl2.value
					? yup.string().required('Bitte füllen Sie das Feld "IBAN" aus.')
					: null,
				Bank: hiddenEl2.value
					? yup.string().required('Bitte füllen Sie das Feld "Bank" aus.')
					: null,
				Kontoinhaber: hiddenEl2.value ? yup.string() : null,
				BIC: hiddenEl2.value ? yup.string() : null,
			})
		})

		const { errors, setValues } = useForm({
			validationSchema: schema,
			initialValues: {
				Rechnung: {},
				AGB: false,
				Widerrufsrecht: false,
				Ausgedruckt: false,
			},
			validateOnMount: false,
		})

		const isValid = useIsFormValid()
		const isDirty = useIsFormDirty()
		const formValues = useFormValues()
		const validate = useValidateForm()

		const { value: Rechnung } = useField('Rechnung')

		const { value: Kundenart } = useField('Rechnung.Kundenart')
		const { value: Anrede } = useField('Rechnung.Anrede')
		const { value: Vorname } = useField('Rechnung.Vorname')
		const { value: Nachname } = useField('Rechnung.Nachname')
		const { value: Street } = useField('Rechnung.Straße')
		const { value: Postleitzahl } = useField('Rechnung.Postleitzahl')
		const { value: Ort } = useField('Rechnung.Ort')
		const { value: Land } = useField('Rechnung.Land')
		const { value: Telefon } = useField('Rechnung.Telefon')
		const { value: Email } = useField('Rechnung.Email')
		let { value: Firma } = useField('Rechnung.Firma')
		let { value: VAT } = useField('Rechnung.VAT-ID')

		const { value: Zahlungsart } = useField('Zahlungsart')
		const { value: AGB } = useField('AGB')
		const { value: Widerrufsrecht } = useField('Widerrufsrecht')
		const { value: Ausgedruckt } = useField('Ausgedruckt')
		let { value: IBAN } = useField('IBAN')
		let { value: Bank } = useField('Bank')
		let { value: Kontoinhaber } = useField('Kontoinhaber')
		let { value: BIC } = useField('BIC')

		const formDataValues = computed(() => {
			return { ...store.state.steps.formData }
		})

		const formData = computed(() => {
			return {
				formValues: { ...formValues.value },
				isValid: isValid.value,
				isDirty: isDirty.value,
				validate: validate,
			}
		})

		onMounted(() => {
			setValues(formDataValues.value)
			if (formDataValues.value.Rechnung) {
				Rechnung.value = formDataValues.value.Rechnung
			}

			if (!Kundenart.value) {
				Kundenart.value = OPTIONS.Kundenart[1]
			}

			if (!Zahlungsart.value) {
				Zahlungsart.value = RADIO_OPTIONS.zahlungsart[0]
			}
		})

		watch(
			() => formData,
			(data) => {
				emit('changed', data)
			},
			{ deep: true }
		)

		watch(
			() => Kundenart.value,
			(newValue, oldValue) => {
				if (
					newValue &&
					oldValue &&
					newValue.value === 'Unternehmen' &&
					oldValue.value === 'Privatperson'
				) {
					Firma.value = ''
					VAT.value = ''
				}
			},
			{ deep: true }
		)

		return {
			kundenartOptions: OPTIONS.Kundenart,
			anredeOptions: OPTIONS.anrede,
			landOptions: OPTIONS.land,

			zahlungsartOptions: RADIO_OPTIONS.zahlungsart,
			tooltipMessage,
			hiddenEl,
			hiddenEl2,

			errors,
			formData,
			AGB_URL,
			AGB_HTML,
			widerrufsrechtDescription,

			Rechnung,
			Kundenart,
			Anrede,
			Vorname,
			Nachname,
			Street,
			Postleitzahl,
			Ort,
			Land,
			Telefon,
			Email,
			Firma,
			VAT,
			Zahlungsart,
			AGB,
			Widerrufsrecht,
			Ausgedruckt,
			IBAN,
			Bank,
			Kontoinhaber,
			BIC,
		}
	},
}
</script>

<style scoped>
:focus {
	outline: none;
}
</style>
